import { render, staticRenderFns } from "./ProductRecommendation.vue?vue&type=template&id=2994e9cc&scoped=true&"
import script from "./ProductRecommendation.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommendation.vue?vue&type=style&index=0&id=2994e9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2994e9cc",
  null
  
)

export default component.exports